import { render, staticRenderFns } from "./InvoiceTax.vue?vue&type=template&id=52c48644&scoped=true"
import script from "./InvoiceTax.vue?vue&type=script&lang=js"
export * from "./InvoiceTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c48644",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c48644')) {
      api.createRecord('52c48644', component.options)
    } else {
      api.reload('52c48644', component.options)
    }
    module.hot.accept("./InvoiceTax.vue?vue&type=template&id=52c48644&scoped=true", function () {
      api.rerender('52c48644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/InvoiceTax.vue"
export default component.exports